import { getSettings } from '@local/services/webApi';

export const LOAD_SETTINGS = 'LOAD_SETTINGS';
const defaultSetting = null;

export default function settingReducer(state = defaultSetting, action) {
  switch (action.type) {
    case LOAD_SETTINGS:
      return action.payload;
    default:
      return state;
  }
};

export function loadSettings() {
  return dispatch => {
    return getSettings()
      .then((response) => {
        const settings = response && response.data && response.data.settings;
        dispatch({ type: LOAD_SETTINGS, payload: settings });
        return response;
      });
  };
};
